import React from 'react';
import { ChoiceCards } from '@ofself/shell';
import './ChoiceList.css';

// THE CHOICE LIST — one of a few options, each with a line on what it means:
// a realm to give someone, a way of doing a grave act. Stacked, tinted, the
// chosen one darker. It is the kit's ChoiceCards (a radio group, the arrows
// moving the choice), in Nucleus's type: the line is read, so it is not mono.
// Two bare words with no line are a Segmented.
//
//   <ChoiceList label="What they can do" value={v} onChange={setV}
//       options={[{ value: 'r1', label: 'Members', hint: 'Sees what the group shares.' }, …]} />
//
// `disabled` holds every option still (`title` says why).

export default function ChoiceList({ options = [], value, onChange, label, disabled = false, title, className = '' }) {
    // the kit speaks strings; each value goes back in the type it came in
    const pick = (v) => onChange?.(options.find((o) => String(o.value) === v)?.value ?? v);
    return (
        <fieldset className={`nx-choice-list${disabled ? ' is-off' : ''} ${className}`.trim()} disabled={disabled} title={title}>
            <ChoiceCards
                aria-label={label}
                options={options.map((o) => ({ value: String(o.value), label: o.label, hint: o.hint || undefined }))}
                value={value == null ? undefined : String(value)}
                onChange={disabled ? undefined : pick}
            />
        </fieldset>
    );
}
